import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const AboutUs = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, setVideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {



        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>
                {/* breadcrumb-section */}
                <section className="breadcrumb-section__area grey-bg">
                    <div className="container">
                        <div className="breadcrumb-section__content">
                            <h2
                                className="breadcrumb-section__title wow custom-anim-left"
                                data-wow-duration="1s"
                                data-wow-delay="0.1s"
                            >
                                Contact Us
                            </h2>

                        </div>
                    </div>
                </section>
                {/* office-location */}

                {/* contact-page */}
                <section className="contact-page__area section-space-bottom">
                    <div className="container">
                        <div className="row mb-minus-24">
                            <div className="col-lg-6">
                                <div
                                    className="contact-page__address mb-24 wow fadeInUp"
                                    data-wow-duration="0.7s"
                                    data-wow-delay="0.2s"
                                >

                                    <div className="contact-page__address-item">
                                        <div className="icon">
                                            <i className="fa-solid fa-phone" />
                                        </div>
                                        <div className="info">
                                            <span>Phone Number &amp; Email</span>
                                            <ul>
                                                <li>
                                                    <a href="tel:08026623007">080-26623007</a>
                                                </li>
                                                <li>
                                                    <a href="tel:9886977701">+91 98869 77701</a>
                                                </li>

                                                <li>
                                                    <a href="tel:9535150008">+91 95351 50008</a>
                                                </li>



                                                <li>
                                                    <a href="mailto:info@venkatadri.in">info@venkatadri.in</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="contact-page__address-item">
                                        <div className="icon">
                                            <i className="fa-solid fa-location-dot" />
                                        </div>
                                        <div className="info">
                                            <span>Corporate Office</span>
                                            <ul>
                                                <li>

                                                    #65, 3rd Floor, SSR Archade, <br />Gandhi Bazaar Main Road, <br />Basavanagudi, Bangalore, Karnataka - 560004

                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    className="contact-page__wrap mb-24 wow fadeInUp"
                                    data-wow-duration="0.7s"
                                    data-wow-delay="0.2s"
                                >

                                    <span>Location</span>
                                    <div className="contact-page__from">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31107.598345544484!2d77.5501734!3d12.9430448!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15f300c74f31%3A0xe4306e239ecbdec4!2sKarnataka%20Police%20TV!5e0!3m2!1sen!2sin!4v1782051751651!5m2!1sen!2sin" width="500" height="450" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>


            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default AboutUs;